import {v4 as uuidv4} from "uuid";
/* eslint-disable no-template-curly-in-string */
import {faker}  from "@faker-js/faker";
import { getOrgApp } from "../helpers/get-orgApp";
import moment from "moment";
import { formatDateToUTC } from "../../utils/convert-date";
import { TERRAFORM_ENV_ID } from "../scenarios/edu-scenarios";

const blueprintNames = [
  "Deploy an ECS cluster",
  "Deploy a Fargate Cluster",
  "Install CloudWatch Agent",
  "Deploy an EMR Cluster",
];
export const blueprintIdByoa = () => {
  return { BlueprintId: "08ba970e-c190-5bd5-8576-df5ac27bdf0b" };
};

export const appParametersByoa = () => {
  return {
    RegionCode: "us-east-2",
    ApplicationId: "543d4e16-4245-472c-a370-af060194215d",
    DepartmentId: "5bba91b7-551f-4d35-a113-b37fcd840a71",
    EnvironmentId: "1c53f18d-ab61-4378-8362-b80e2aeda768",
    AccountNumber: "568753834354",
    Status: "DELETE_COMPLETE",
    StackName: "Elastic-Search-Setup--2019-09-11--12-37-00",
    CreatedOn: "2019-09-13 14:27:07",
    LaunchRole:
      "arn:aws:iam::568753834354:role/MontyCloud-BYOACloudFormationRole",
    Output: [
      {
        OutputKey: "Role",
        OutputValue: `MontyCloud-${uuidv4()}-EC2Role`,
      },
      {
        OutputKey: "InstanceId",
        OutputValue: "i-09c614b73ee811111",
      },
      {
        OutputKey: "InstancePrivateIp",
        OutputValue: faker.internet.ip(),
      },
    ],
    Parameters: [
      {
        ParameterKey: "Application",
        ParameterValue: "App_21",
      },
      {
        ParameterKey: "Environment",
        ParameterValue: "dev",
      },
      {
        ParameterKey: "InstanceName",
        ParameterValue: "EC2 Instance",
      },
      {
        ParameterKey: "OperatingSystem",
        ParameterValue: "AmazonLinux2",
      },
      {
        ParameterKey: "VPC",
        ParameterValue: "vpc-4f5b6327",
      },
      {
        ParameterKey: "Subnet",
        ParameterValue: "subnet-1218e52c",
      },
      {
        ParameterKey: "ESDataInstanceVolumeSize",
        ParameterValue: "20",
      },
      {
        ParameterKey: "ESDataInstanceVolumeType",
        ParameterValue: "gp2",
      },
      {
        ParameterKey: "EBSOptimized",
        ParameterValue: "false",
      },
      {
        ParameterKey: "BlockDeviceDeleteOnTermination",
        ParameterValue: "true",
      },
      {
        ParameterKey: "SecurityGroup",
        ParameterValue: "sg-0008bef9e622b9c17",
      },
      {
        ParameterKey: "InstanceType",
        ParameterValue: "t2.medium",
      },
      {
        ParameterKey: "EC2KeyPair",
        ParameterValue: "",
      },
      {
        ParameterKey: "PolicyName",
        ParameterValue: "",
      },
    ],
    BlueprintId: "7a8e592d-5e37-47ac-877d-c44a817dafc4",
  };
};
export const bringYourOwnAppTemplate = () => {
  return {
    ParentTemplateContent: JSON.stringify(template),
  };
};

export const bringYourOwnAppManifest = () => {
  return {
    ManifestTemplateContent: manifestTemplate,
  };
};

export const getBringYourOwnAppParameterGroups = () => {
  return {
    parameterGroups: manifestTemplate.parameters.parameterGroups,
    ManifestTemplateContent: manifestTemplate,
  };
};

export const getCompletedTerraformExecutionHistory = async () => {
  //
  let orgAppDetails = await getOrgApp();
  let selectedOrg = faker.helpers.arrayElement(orgAppDetails);

  return [
    {
      AccountNumber: "904433914959",
      RegionCode: "us-east-1",
      Status: "Create Completed",
      StackName: "S3",
      CreatedOn: formatDateToUTC( moment().subtract(2) ), 
      EnvironmentId: TERRAFORM_ENV_ID, // Terraform-Protein-Research
      OrganizationId: selectedOrg.orgId,
      ApplicationId: TERRAFORM_ENV_ID, // Protein-Research
      DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71", // protien research
    },
  ];
};

export const getStacksDataByoa = async (type) => {
  let stacks = [];
  let counter = 5;
  let status = ["Create Completed"];
  if (type === "all") {
    counter = 15;
  }
  for (var i = 0; i < counter; i++) {
    let date = faker.date.between("2019-08-01", "2019-09-15");
    let orgAppDetails = await getOrgApp();
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    var stack = {
      AccountNumber: "904433914959",
      RegionCode: "us-east-1",
      Status: faker.helpers.arrayElement(status),
      StackName:
        "Bring-your-own-app" +
        "--" +
        moment(date).format("YYYY-MM-DD") +
        "--" +
        moment().format("HH-mm-ss"),
      CreatedOn: formatDateToUTC(date),
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      OrganizationId: selectedOrg.orgId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      DepartmentId: selectedDept.deptId,
    };
    if (type === "all") {
      stack.BlueprintName = faker.helpers.arrayElement(blueprintNames);
    }
    stacks.push(stack);
  }

  return stacks;
};

export const getBundledActionsByoa = () => {
  return [
    {
      ApplicationId: null,
      BlueprintId: null,
      Category: "BlueprintAction",
      actionId: "8aca783d-d56f-4865-b2f8-f62cdf2ba649",
      description:
        "Setup CloudWatch Alarms for the actions of Application Servers",
      enabled: true,
      isImported: false,
      metadata: { Label: "Setup Alerts" },
      name: "EnableInfrastructureAlerts",
      owner: "MontyCloud",
      type: "CloudFormationNew",
    },
    {
      ApplicationId: null,
      BlueprintId: null,
      Category: "BlueprintAction",
      actionId: "7922f940-2a25-4d08-80a7-41594b4c3582",
      description:
        "Change the Instance type to increase the compute and storage power for the application",
      enabled: true,
      isImported: false,
      metadata: { Label: "Change Instance Type" },
      name: "ChangeInstanceType",
      owner: "MontyCloud",
      type: "CloudFormationUpdate",
    },
    {
      ApplicationId: null,
      BlueprintId: null,
      Category: "BlueprintAction",
      actionId: "53669367-50c7-472c-a4f1-06608b856b18",
      description:
        "Updates the Auto Scaling Group to have the AMI Id with latest changes of the Application",
      enabled: true,
      isImported: false,
      metadata: { Label: "Update Application" },
      name: "UpdateApplication",
      owner: "MontyCloud",
      type: "CloudFormationUpdate",
    },
    {
      ApplicationId: null,
      BlueprintId: null,
      Category: "BlueprintAction",
      actionId: "f6137a06-cbfb-4b90-853e-4b4ebd950ebc",
      description:
        "Scale the Application to have the right Instance count during peak hours of traffic flow",
      enabled: true,
      isImported: false,
      metadata: { Label: "Scale Application" },
      name: "ScaleApplication",
      owner: "MontyCloud",
      type: "CloudFormationUpdate",
    },
    {
      ApplicationId: null,
      BlueprintId: null,
      Category: "BlueprintAction",
      actionId: "10e62ce6-babe-4e4c-a07f-40341821bc9b",
      description: "Update the DNS Settings of the Application",
      enabled: true,
      isImported: false,
      metadata: { Label: "Update DNS Settings" },
      name: "UpdateDNSSettings",
      owner: "MontyCloud",
      type: "CloudFormationUpdate",
    },
    {
      ApplicationId: null,
      BlueprintId: null,
      Category: "EC2",
      actionId: "02f48973-ab10-5a2f-b17a-c6ee71eb0f68",
      description: "Bake AMI",
      enabled: true,
      isImported: false,
      metadata: {},
      name: "bake",
      owner: "MontyCloud",
      type: "DAY2",
    },
  ];
};
export const getMetricsDataByoa = (data) => {
  // const metrics = data;
  let dataPoints = [];
  for (let i = 0; i < 35; i++) {
    let date;
    switch (parseInt(data.period)) {
      case 1:
        date = `2020-06-02 04:${faker.number.int(58) + 1}:00+00:00`;
        break;
      case 3:
        date = `2020-06-02 ${faker.number.int(2) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 5:
        date = `2020-06-02 ${faker.number.int(4) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 8:
        date = `2020-06-02 ${faker.number.int(7) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 12:
        date = `2020-06-02 ${faker.number.int(11) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 24:
        date = `2020-06-02 ${faker.number.int(22) + 1}:${faker.number.int(
          59
        )}:00+00:00`;
        break;
      case 168:
        date = `2020-06-${faker.number.int(6) + 1} ${faker.number.int(
          24
        )}:${faker.number.int(59)}:00+00:00`;
        break;
      case 336:
        date = `2020-06-${faker.number.int(13) + 1} ${faker.number.int(
          24
        )}:${faker.number.int(59)}:00+00:00`;
        break;
      case 672:
        date = `2020-06-${faker.number.int(27) + 1} ${faker.number.int(
          24
        )}:${faker.number.int(59)}:00+00:00`;
        break;
      default:
        break;
    }
    const num = faker.number.int({ min: 0, max: 10 });
    const item = {
      SampleCount: num,
      Timestamp: date.toLocaleString(),
      Average: num,
      Maximum: num,
      Minimum: num,
      Sum: num,
      Unit: "None",
    };
    dataPoints.push(item);
  }
  return {
    DataPoints: dataPoints,
    MetricName: data.metricName,
  };
};

const manifestTemplate = {
  Capabilities: [
    "CAPABILITY_IAM",
    "CAPABILITY_AUTO_EXPAND",
    "CAPABILITY_NAMED_IAM",
  ],
  actions: [
    {
      actionId: "8aca783d-d56f-4865-b2f8-f62cdf2ba649",
      description:
        "Setup CloudWatch Alarms for the actions of Application Servers",
      enabled: true,
      label: "Setup Alerts",
      name: "EnableInfrastructureAlerts",
      owner: "MontyCloud",
      script: {
        Parameters: {
          parameterGroups: [
            {
              id: "1905919778317-0",
              label: "Import Parameters",
              parameters: [
                {
                  description: "Stack name of the BYOA parent stack.",
                  existingParameter: false,
                  id: 3836943501903,
                  parameterKey: "ParentStack",
                  parameterLabel: "Parent Stack Name",
                  parameterType: "String",
                  primaryKey: {
                    label: "Name",
                    value: "Name",
                  },
                },
                {
                  description:
                    "Specify the type of Load Balancer required for the application.",
                  existingParameter: false,
                  id: 5562029474002,
                  parameterKey: "LoadBalancerType",
                  parameterLabel: "Load Balancer Type",
                  parameterType: "String",
                },
              ],
            },
            {
              id: "5149700870863-1",
              label: "Application Alert Configuration Parameters",
              parameters: [
                {
                  description:
                    "Please specify the SNS Topic ARN of an existing SNS Topic or Specify the Email address in the next parameter to create a new SNS Topic",
                  existingParameter: false,
                  id: 3860048768149,
                  isOptional: true,
                  parameterKey: "ExistingTopicArn",
                  parameterLabel: "Existing SNS Topic Arn",
                  parameterType: "String",
                },
                {
                  description:
                    "Optional, Email address that will receive alerts.",
                  existingParameter: false,
                  id: 1843334226799,
                  isOptional: true,
                  parameterKey: "Email",
                  parameterLabel: "Email Address",
                  parameterType: "String",
                },
                {
                  description:
                    "Optional HTTP endpoint that will receive alerts via POST requests.",
                  existingParameter: false,
                  id: 7865662356631,
                  isOptional: true,
                  parameterKey: "HttpEndpoint",
                  parameterLabel: "Http Endpoint",
                  parameterType: "String",
                },
                {
                  description:
                    "Optional HTTPS endpoint that will receive alerts via POST requests (e.g., a marbot.io endpoint for incident management in Slack).",
                  existingParameter: false,
                  id: 7195452225232,
                  isOptional: true,
                  parameterKey: "HttpsEndpoint",
                  parameterLabel: "Https Endpoint",
                  parameterType: "String",
                },
              ],
            },
          ],
        },
      },
      templateURL: "byoa_ha/byoa_ha_monitoring_template.json",
      type: "CloudFormationNew",
    },
    {
      actionId: "7922f940-2a25-4d08-80a7-41594b4c3582",
      description:
        "Change the Instance type to increase the compute and storage power for the application",
      enabled: true,
      label: "Change Instance Type",
      name: "ChangeInstanceType",
      owner: "MontyCloud",
      script: {
        Parameters: {
          parameterGroups: [
            {
              id: "1593719311305-0",
              label: "Instance Settings",
              parameters: [
                {
                  allowedValues: [
                    "t2.micro",
                    "t2.medium",
                    "t2.small",
                    "t2.large",
                    "t2.xlarge",
                    "t2.2xlarge",
                    "t3a.small",
                    "t3a.medium",
                    "t3a.large",
                    "t3a.xlarge",
                    "t3a.2xlarge",
                    "m5a.xlarge",
                    "m5a.2xlarge",
                    "m5a.4xlarge",
                    "m5a.8xlarge",
                    "m5a.12xlarge",
                    "m5a.16xlarge",
                    "m5a.24xlarge",
                    "c5.large",
                    "c5.xlarge",
                    "c5.2xlarge",
                    "c5.4xlarge",
                    "c5.9xlarge",
                    "c5.12xlarge",
                    "c5.18xlarge",
                    "c5.24xlarge",
                    "m5.large",
                    "m5.xlarge",
                    "m5.2xlarge",
                    "m5.4xlarge",
                    "m5.8xlarge",
                    "m5.12xlarge",
                    "m5.16xlarge",
                    "m5.24xlarge",
                  ],
                  defaultValue: "t2.medium",
                  description:
                    "Enter the instance type for the Application Server.",
                  existingParameter: false,
                  id: 1593719459825,
                  parameterKey: "ApplicationInstanceType",
                  parameterLabel: "Application Server Instance Type",
                  parameterType: "List",
                },
              ],
            },
          ],
        },
      },
      type: "CloudFormationUpdate",
    },
    {
      actionId: "53669367-50c7-472c-a4f1-06608b856b18",
      description:
        "Updates the Auto Scaling Group to have the AMI Id with latest changes of the Application",
      enabled: true,
      label: "Update Application",
      name: "UpdateApplication",
      owner: "MontyCloud",
      script: {
        Parameters: {
          parameterGroups: [
            {
              id: "1593719489529-0",
              label: "Update Application",
              parameters: [
                {
                  description:
                    "Updated AMI ID for the application to have all the latest changes.",
                  existingParameter: false,
                  id: 1593719638918,
                  parameterKey: "ApplicationAMI",
                  parameterLabel: "Updated Application Server AMI Id",
                  parameterType: "String",
                },
              ],
            },
          ],
        },
      },
      type: "CloudFormationUpdate",
    },
    {
      actionId: "f6137a06-cbfb-4b90-853e-4b4ebd950ebc",
      description:
        "Scale the Application to have the right Instance count during peak hours of traffic flow",
      enabled: true,
      label: "Scale Application",
      name: "ScaleApplication",
      owner: "MontyCloud",
      script: {
        Parameters: {
          parameterGroups: [
            {
              id: "1593719710685-0",
              label: "Update Auto Scaling Instance Count",
              parameters: [
                {
                  description:
                    "The desired count of the Instances in the Auto Scaling group",
                  existingParameter: false,
                  id: 1593719756076,
                  parameterKey: "DesiredCount",
                  parameterLabel: "Desired Count of Instances",
                  parameterType: "Number",
                },
                {
                  description:
                    "The maximum instance counts to be configured for Auto Scaling group.",
                  existingParameter: false,
                  id: 1593719947270,
                  parameterKey: "MaxSize",
                  parameterLabel: "Maximum number of Instances",
                  parameterType: "Number",
                },
                {
                  description:
                    "The minimum instance counts to be configured for Auto Scaling group.",
                  existingParameter: false,
                  id: 1593720026074,
                  parameterKey: "MinSize",
                  parameterLabel: "Minimum number of Instances",
                  parameterType: "Number",
                },
              ],
            },
          ],
        },
      },
      type: "CloudFormationUpdate",
    },
    {
      actionId: "10e62ce6-babe-4e4c-a07f-40341821bc9b",
      description: "Update the DNS Settings of the Application",
      enabled: true,
      label: "Update DNS Settings",
      name: "UpdateDNSSettings",
      owner: "MontyCloud",
      script: {
        Parameters: {
          parameterGroups: [
            {
              id: "1593720059768-0",
              label: "DNS Settings Parameters",
              parameters: [
                {
                  description:
                    "Route 53 Hosted Zone Name with trailing dot. Eg {hostedzonename.com.}",
                  existingParameter: false,
                  id: 1593720164039,
                  parameterKey: "HostedZoneName",
                  parameterLabel: "Route53 Hosted Zone Name",
                  parameterType: "HostedZone",
                  primaryKey: {
                    label: "Name",
                    value: "Name",
                  },
                },
                {
                  description:
                    "Name that is used to create the DNS entry with trailing dot Eg.{Subdomainname.}",
                  existingParameter: false,
                  id: 1593720209065,
                  parameterKey: "SubDomainName",
                  parameterLabel: "Sub Domain Name",
                  parameterType: "String",
                },
              ],
            },
          ],
        },
      },
      type: "CloudFormationUpdate",
    },
  ],
  kind: "blueprint",
  metadata: {
    author: "MontyCloud",
    category: "Application Blueprints",
    description:
      "Build DAY2 ready Server Apps. Import any Windows/Linux Server based apps and automatically enable HA, network connectivity, fault tolerance, auto scaling, monitoring and ops automation along with security best practices",
    diagram_name: "byoa_ha_diagram.png",
    name: "Transform Server Apps for Cloud and Ops Readiness",
    parent_template: "byoa_ha_master_template.json",
    path: "byoa_ha/",
    permission_cfn: "byoa_ha_permission.json",
    sub_category: "Compute",
    type: "CFN",
    version: 1.0,
  },
  monitoring: {
    metrics: [
      {
        dimensionName: "BucketName",
        id: "1593717503476-0",
        metrics: {
          name: "BucketSizeBytes",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-1",
        metrics: {
          name: "NumberOfObjects",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-2",
        metrics: {
          name: "AllRequests",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-3",
        metrics: {
          name: "GetRequests",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-4",
        metrics: {
          name: "PutRequests",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-5",
        metrics: {
          name: "DeleteRequests",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-6",
        metrics: {
          name: "HeadRequests",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-7",
        metrics: {
          name: "PostRequests",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-8",
        metrics: {
          name: "ListRequests",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-9",
        metrics: {
          name: "4xxErrors",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-10",
        metrics: {
          name: "5xxErrors",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "BucketName",
        id: "1593717503476-11",
        metrics: {
          name: "TotalRequestLatency",
          type: "S3 Bucket",
        },
        namespace: "AWS/S3",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525338-0",
        metrics: {
          name: "ActiveFlowCount",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525338-1",
        metrics: {
          name: "ActiveFlowCount_TCP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525338-2",
        metrics: {
          name: "ActiveFlowCount_TLS",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525338-3",
        metrics: {
          name: "ActiveFlowCount_UDP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525338-4",
        metrics: {
          name: "ClientTLSNegotiationErrorCount",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525338-5",
        metrics: {
          name: "ConsumedLCUs",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525338-6",
        metrics: {
          name: "ConsumedLCUs_TCP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-7",
        metrics: {
          name: "ConsumedLCUs_TLS",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-8",
        metrics: {
          name: "NewFlowCount",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-9",
        metrics: {
          name: "ConsumedLCUs_UDP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-10",
        metrics: {
          name: "NewFlowCount_TCP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-11",
        metrics: {
          name: "NewFlowCount_TLS",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-12",
        metrics: {
          name: "NewFlowCount_UDP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-13",
        metrics: {
          name: "ProcessedBytes",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-14",
        metrics: {
          name: "ProcessedBytes_TCP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-15",
        metrics: {
          name: "ProcessedBytes_TLS",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-16",
        metrics: {
          name: "ProcessedBytes_UDP",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-17",
        metrics: {
          name: "TCP_Client_Reset_Count",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-18",
        metrics: {
          name: "TCP_ELB_Reset_Count",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-19",
        metrics: {
          name: "TCP_Target_Reset_Count",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717525339-20",
        metrics: {
          name: "UnHealthyHostCount",
          type: "Network Load Balancer",
        },
        namespace: "AWS/NetworkELB",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-0",
        metrics: {
          name: "CPUUtilization",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-1",
        metrics: {
          name: "DiskReadOps",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-2",
        metrics: {
          name: "DiskWriteOps",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-3",
        metrics: {
          name: "EBSReadOps",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-4",
        metrics: {
          name: "EBSWriteOps",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-5",
        metrics: {
          name: "StatusCheckFailed",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-6",
        metrics: {
          name: "NetworkIn",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "AutoScalingGroupName",
        id: "1593717534579-7",
        metrics: {
          name: "NetworkOut",
          type: "Auto Scaling Group",
        },
        namespace: "AWS/EC2",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-0",
        metrics: {
          name: "ActiveConnectionCount",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-1",
        metrics: {
          name: "HTTP_Fixed_Response_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-2",
        metrics: {
          name: "HTTP_Redirect_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-3",
        metrics: {
          name: "HTTP_Redirect_Url_Limit_Exceeded_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-4",
        metrics: {
          name: "HTTPCode_ELB_3XX_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-5",
        metrics: {
          name: "HTTPCode_ELB_5XX_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-6",
        metrics: {
          name: "HTTPCode_ELB_4XX_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-7",
        metrics: {
          name: "HTTPCode_ELB_500_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-8",
        metrics: {
          name: "HTTPCode_ELB_502_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-9",
        metrics: {
          name: "HTTPCode_ELB_503_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-10",
        metrics: {
          name: "HTTPCode_ELB_504_Count",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-11",
        metrics: {
          name: "NewConnectionCount",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
      {
        dimensionName: "LoadBalancer",
        id: "1593717548505-12",
        metrics: {
          name: "RequestCount",
          type: "Application Load Balancer",
        },
        namespace: "AWS/ApplicationELB",
      },
    ],
    order: [
      "1593717503476-0",
      "1593717503476-1",
      "1593717503476-2",
      "1593717503476-3",
      "1593717503476-4",
      "1593717503476-5",
      "1593717503476-6",
      "1593717503476-7",
      "1593717503476-8",
      "1593717503476-9",
      "1593717503476-10",
      "1593717503476-11",
      "1593717525338-0",
      "1593717525338-1",
      "1593717525338-2",
      "1593717525338-3",
      "1593717525338-4",
      "1593717525338-5",
      "1593717525338-6",
      "1593717525339-7",
      "1593717525339-8",
      "1593717525339-9",
      "1593717525339-10",
      "1593717525339-11",
      "1593717525339-12",
      "1593717525339-13",
      "1593717525339-14",
      "1593717525339-15",
      "1593717525339-16",
      "1593717525339-17",
      "1593717525339-18",
      "1593717525339-19",
      "1593717525339-20",
      "1593717534579-0",
      "1593717534579-1",
      "1593717534579-2",
      "1593717534579-3",
      "1593717534579-4",
      "1593717534579-5",
      "1593717534579-6",
      "1593717534579-7",
      "1593717548505-0",
      "1593717548505-1",
      "1593717548505-2",
      "1593717548505-3",
      "1593717548505-4",
      "1593717548505-5",
      "1593717548505-6",
      "1593717548505-7",
      "1593717548505-8",
      "1593717548505-9",
      "1593717548505-10",
      "1593717548505-11",
      "1593717548505-12",
    ],
  },
  parameters: {
    parameterGroups: [
      {
        id: "1593716606221-0",
        label: "Application Configuration",
        parameters: [
          {
            description: "Application",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "Application",
            parameterLabel: "Application",
            parameterType: "String",
            parameterValue: "",
          },
          {
            description: "Name of the Environment. Eg. Dev, Staging, Prod.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "Environment",
            parameterLabel: "Environment",
            parameterType: "String",
            parameterValue: "",
          },
          {
            description: "Application Id",
            existingParameter: true,
            hideParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "ApplicationId",
            parameterLabel: "ApplicationId",
            parameterType: "String",
            parameterValue: "",
          },
        ],
      },
      {
        id: "1593716606222-1",
        label: "EC2 Instances Parameters",
        parameters: [
          {
            description: "Name of the Application Server",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "ApplicationServerName",
            parameterLabel: "Application Server Name",
            parameterType: "String",
            parameterValue: "",
          },
          {
            defaultValue: "80",
            description: "Port number on the Application Server",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "ApplicationPort",
            parameterLabel: "Application Server Port",
            parameterType: "Number",
            parameterValue: "",
          },
          {
            defaultValue: "",
            description:
              "Optional key pair of the ec2-user to establish a SSH connection to the EC2 instances of App server.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: true,
            keyField: "resourceId",
            minRecordsToBeSelected: "1",
            parameterKey: "KeyName",
            parameterLabel: "Key Pair Name",
            parameterType: "KeyPair",
            parameterValue: "",
            primaryKey: {
              label: "Name",
              value: "Name",
            },
          },
          {
            defaultValue: "",
            description:
              "Optional comma-delimited list of IAM managed policy ARNs to attach to the instance's IAM role",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: true,
            keyField: "resourceId",
            parameterKey: "ManagedPolicyArns",
            parameterLabel: "IAM Managed Policy Arns.",
            parameterType: "String",
            parameterValue: "",
          },
          {
            allowedValues: [
              "t2.micro",
              "t2.medium",
              "t2.small",
              "t2.large",
              "t2.xlarge",
              "t2.2xlarge",
              "t3a.small",
              "t3a.medium",
              "t3a.large",
              "t3a.xlarge",
              "t3a.2xlarge",
              "m5a.xlarge",
              "m5a.2xlarge",
              "m5a.4xlarge",
              "m5a.8xlarge",
              "m5a.12xlarge",
              "m5a.16xlarge",
              "m5a.24xlarge",
              "c5.large",
              "c5.xlarge",
              "c5.2xlarge",
              "c5.4xlarge",
              "c5.9xlarge",
              "c5.12xlarge",
              "c5.18xlarge",
              "c5.24xlarge",
              "m5.large",
              "m5.xlarge",
              "m5.2xlarge",
              "m5.4xlarge",
              "m5.8xlarge",
              "m5.12xlarge",
              "m5.16xlarge",
              "m5.24xlarge",
            ],
            defaultValue: "t2.medium",
            description: "The instance type of the Application Server.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "ApplicationInstanceType",
            parameterLabel: "Application Server Instance Type.",
            parameterType: "List",
            parameterValue: "",
          },
          {
            description: "The Application AMI ID.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "ApplicationAMI",
            parameterLabel: "Application Server AMI Id.",
            parameterType: "Image",
            parameterValue: "",
          },
          {
            defaultValue: "50",
            description:
              "The volume size for the Application Server, in gibibytes (GiBs)",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "InstancesRootVolumeSize",
            parameterLabel: "Application Server Root Volume Size in GiB's",
            parameterType: "Number",
            parameterValue: "",
          },
        ],
      },
      {
        id: "1593716606222-2",
        label: "VPC Network Parameters",
        parameters: [
          {
            description: "The ID of the VPC",
            existingParameter: true,
            initialTemplateType: "VPC",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            minRecordsToBeSelected: "1",
            parameterKey: "VPC",
            parameterLabel: "VPC ID.",
            parameterType: "VPC",
            parameterValue: "",
            primaryKey: {
              label: "ID",
              value: "ID",
            },
          },
          {
            description:
              "Choose two Public Subnets in different Availability Zones for public clusters or Private Subnets for non-internet facing clusters.",
            existingParameter: true,
            filterBy: {
              label: "VPC",
              value: "VPC",
            },
            initialTemplateType: "Subnet",
            isMultiSelect: true,
            isOptional: false,
            keyField: "resourceId",
            minRecordsToBeSelected: "2",
            parameterKey: "ApplicationSubnetIds",
            parameterLabel: "Application Server SubnetIds",
            parameterType: "Subnet",
            parameterValue: "",
            primaryKey: {
              label: "ID",
              value: "ID",
            },
          },
          {
            description:
              "Choose two public subnets if Load Balancer should be internet-facing or private subnets if Load Balancer should be internal. Make sure to choose Subnets in different Availability Zones.",
            existingParameter: true,
            filterBy: {
              label: "VPC",
              value: "VPC",
            },
            hideParameter: false,
            initialTemplateType: "Subnet",
            isMultiSelect: true,
            isOptional: false,
            keyField: "resourceId",
            minRecordsToBeSelected: "2",
            parameterKey: "LoadBalancerSubnetIds",
            parameterLabel: "Elastic Load Balancer Subnet Id",
            parameterType: "Subnet",
            parameterValue: "",
            primaryKey: {
              label: "ID",
              value: "ID",
            },
          },
          {
            description:
              "Optional, Database or any other Security Group Id to be attached to the Auto-Scaling Security Group",
            existingParameter: true,
            filterBy: {
              label: "VPC",
              value: "VPC",
            },
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: true,
            keyField: "resourceId",
            minRecordsToBeSelected: "1",
            parameterKey: "DatabaseSecurityGroupId",
            parameterLabel: "Security Group Id for ASG",
            parameterType: "SecurityGroup",
            parameterValue: "",
            primaryKey: {
              label: "ID",
              value: "ID",
            },
          },
          {
            defaultValue: "0.0.0.0/0",
            description:
              "Allowed CIDR block for external access to the Application Server.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "RemoteAccessCIDR",
            parameterLabel: "Remote Access CIDR Block",
            parameterType: "String",
            parameterValue: "",
          },
        ],
      },
      {
        id: "1593716606222-3",
        label: "Elastic Load Balancer Parameters",
        parameters: [
          {
            allowedValues: ["Network", "Application"],
            defaultValue: "Network",
            description:
              "Specify the type of Load Balancer required for the application",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "LoadBalancerType",
            parameterLabel: "Elastic Load Balancer Type",
            parameterType: "List",
            parameterValue: "",
          },
          {
            allowedValues: ["internet-facing", "internal"],
            defaultValue: "internet-facing",
            description:
              "Indicates whether the load balancer in front of the EC2 Instance is internet-facing or internal.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "LoadBalancerScheme",
            parameterLabel: "Elastic Load Balancer Scheme",
            parameterType: "List",
            parameterValue: "",
          },
          {
            defaultValue: "60",
            description: "The idle timeout value, in seconds.",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "LoadBalancerIdleTimeout",
            parameterLabel: "Load Balancer Idle Timeout",
            parameterType: "Number",
            parameterValue: "",
          },
          {
            defaultValue: "300",
            description:
              "The amount time (in seconds) to wait before changing the state of a deregistering target from draining to unused.",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "LoadBalancerDeregistrationDelay",
            parameterLabel: "Load Balancer Deregistration Delay Time",
            parameterType: "Number",
            parameterValue: "",
          },
          {
            defaultValue: "",
            description:
              "Optional Amazon Certificate ARN. Leave it blank if you dont have one",
            existingParameter: true,
            hideParameter: false,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: true,
            keyField: "resourceId",
            parameterKey: "CertificateARN",
            parameterLabel: "Certificate ARN",
            parameterType: "Certificate",
            parameterValue: "",
            primaryKey: {
              label: "ARN",
              value: "ARN",
            },
          },
          {
            allowedValues: ["true", "false"],
            defaultValue: "true",
            description:
              "Enables Load Balancer Access logs and stores in a S3 Bucket.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "EnableELBAccessLogs",
            parameterLabel: "Enable ELB Access Log",
            parameterType: "List",
            parameterValue: "",
          },
        ],
      },
      {
        id: "1593716606222-4",
        label: "AutoScaling Group Parameters",
        parameters: [
          {
            defaultValue: "2",
            description:
              "The desired count of the Instances in the Auto Scaling group",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "DesiredCount",
            parameterLabel: "Desired Count of Instances",
            parameterType: "Number",
            parameterValue: "",
          },
          {
            defaultValue: "4",
            description: "The maximum size of the Auto Scaling group.",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "MaxSize",
            parameterLabel: "Maximum number of Instances",
            parameterType: "Number",
            parameterValue: "",
          },
          {
            defaultValue: "2",
            description: "The minimum size of the Auto Scaling group.",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "MinSize",
            parameterLabel: "Minimum number of Instances",
            parameterType: "Number",
            parameterValue: "",
          },
          {
            defaultValue: "60",
            description: "CPU Utilization Target Value in Percentage",
            existingParameter: true,
            initialTemplateType: "Number",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "CPUPolicyTargetValue",
            parameterLabel:
              "CPU Uitlization Threshold Value in Percentage to Scale",
            parameterType: "Number",
            parameterValue: "",
          },
          {
            allowedValues: ["true", "false"],
            defaultValue: "false",
            description:
              "Indicates whether scale in property of the Auto-Scaling scaling policy is disabled.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: false,
            keyField: "resourceId",
            parameterKey: "DisableScaleIn",
            parameterLabel: "Disable Instances Scale In",
            parameterType: "List",
            parameterValue: "",
          },
        ],
      },
      {
        id: "1593716606222-5",
        label: "Hosted Zone Parameters",
        parameters: [
          {
            defaultValue: "",
            description:
              "Optional Route 53 Hosted Zone Name with trailing dot. Eg. {hostedzonename.com.} Leave it blank if you dont have one.",
            existingParameter: true,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: true,
            keyField: "resourceId",
            parameterKey: "HostedZoneName",
            parameterLabel: "Route53 Hosted Zone Name",
            parameterType: "HostedZone",
            parameterValue: "",
            primaryKey: {
              label: "Name",
              value: "Name",
            },
          },
          {
            defaultValue: "",
            description:
              "Name that is used to create the DNS entry with trailing dot Eg. {Subdomainname.}",
            existingParameter: true,
            hideParameter: false,
            initialTemplateType: "String",
            isMultiSelect: false,
            isOptional: true,
            keyField: "resourceId",
            parameterKey: "SubDomainName",
            parameterLabel: "Sub Domain Name",
            parameterType: "String",
            parameterValue: "",
          },
        ],
      },
    ],
  },
  prerequisites: [
    "VPC ID to provision the Application",
    "Minimum of two Subnets in different AZs for high availability",
    "AMI Id with pre-deployed application and configurations",
    "Port number for the Application communication",
    "Optional EC2 Key Pair",
    "Optional route 53 Hosted Zone",
    "Optional Amazon Ceritificate for HTTPS",
  ],
  roleName: "MontyCloud-BYOACloudFormationRole",
  template: {
    permissions: [],
    type: "cloudformation",
  },
  version: 1.0,
};

const template = {
  AWSTemplateFormatVersion: "2010-09-09",
  Description:
    "Import any application and automatically enable HA, network connectivity, fault tolerance, auto scaling, monitoring, ops automation along with security best practices",
  Metadata: {
    "AWS::CloudFormation::Interface": {
      ParameterGroups: [
        {
          Label: {
            default: "Application Configuration",
          },
          Parameters: ["Application", "Environment"],
        },
        {
          Label: {
            default: "EC2 Instances Parameters",
          },
          Parameters: [
            "ApplicationServerName",
            "ApplicationPort",
            "KeyName",
            "ManagedPolicyArns",
            "ApplicationInstanceType",
            "ApplicationAMI",
            "InstancesRootVolumeSize",
          ],
        },
        {
          Label: {
            default: "VPC Network Parameters",
          },
          Parameters: [
            "VPC",
            "ApplicationSubnetIds",
            "LoadBalancerSubnetIds",
            "DatabaseSecurityGroupId",
            "RemoteAccessCIDR",
          ],
        },
        {
          Label: {
            default: "Elastic Load Balancer Parameters",
          },
          Parameters: [
            "LoadBalancerType",
            "LoadBalancerScheme",
            "LoadBalancerIdleTimeout",
            "LoadBalancerDeregistrationDelay",
            "CertificateARN",
            "EnableELBAccessLogs",
          ],
        },
        {
          Label: {
            default: "AutoScaling Group Parameters",
          },
          Parameters: [
            "DesiredCount",
            "MaxSize",
            "MinSize",
            "CPUPolicyTargetValue",
            "DisableScaleIn",
          ],
        },
        {
          Label: {
            default: "Hosted Zone Parameters",
          },
          Parameters: ["HostedZoneName", "SubDomainName"],
        },
      ],
      ParameterLabels: {
        VPC: {
          default: "VPC ID.",
        },
        Application: {
          default: "Application",
        },
        Environment: {
          default: "Environment",
        },
        ApplicationServerName: {
          default: "Application Server Name",
        },
        KeyName: {
          default: "Key Pair Name",
        },
        ManagedPolicyArns: {
          default: "IAM Managed Policy Arns.",
        },
        ApplicationInstanceType: {
          default: "Application Server Instance Type.",
        },
        ApplicationAMI: {
          default: "Application Server AMI Id.",
        },
        InstancesRootVolumeSize: {
          default: "Application Server Root Volume Size in GiB's",
        },
        ApplicationSubnetIds: {
          default: "Application Server SubnetIds",
        },
        LoadBalancerSubnetIds: {
          default: "Elastic Load Balancer Subnet Id",
        },
        LoadBalancerScheme: {
          default: "Elastic Load Balancer Scheme",
        },
        ApplicationPort: {
          default: "Application Server Port",
        },
        DesiredCount: {
          default: "Desired Count of Instances",
        },
        MaxSize: {
          default: "Maximum number of Instances",
        },
        MinSize: {
          default: "Minimum number of Instances",
        },
        CPUPolicyTargetValue: {
          default: "CPU Uitlization Threshold Value in Percentage to Scale",
        },
        CertificateARN: {
          default: "Certificate ARN",
        },
        HostedZoneName: {
          default: "Route53 Hosted Zone Name",
        },
        DisableScaleIn: {
          default: "Disable Instances Scale In",
        },
        EnableELBAccessLogs: {
          default: "Enable ELB Access Log",
        },
        LoadBalancerIdleTimeout: {
          default: "Load Balancer Idle Timeout",
        },
        LoadBalancerDeregistrationDelay: {
          default: "Load Balancer Deregistration Delay Time",
        },
        LoadBalancerType: {
          default: "Elastic Load Balancer Type",
        },
        RemoteAccessCIDR: {
          default: "Remote Access CIDR Block",
        },
        DatabaseSecurityGroupId: {
          default: "Security Group Id for ASG",
        },
        SubDomainName: {
          default: "Sub Domain Name",
        },
      },
    },
  },
  Parameters: {
    Application: {
      Type: "String",
      Description: "Application",
    },
    Environment: {
      Type: "String",
      Description: "Name of the Environment. Eg. Dev, Staging, Prod.",
    },
    KeyName: {
      Description:
        "Optional key pair of the ec2-user to establish a SSH connection to the EC2 instances of App server.",
      Type: "String",
      Default: "",
    },
    ManagedPolicyArns: {
      Description:
        "Optional comma-delimited list of IAM managed policy ARNs to attach to the instance's IAM role",
      Type: "String",
      Default: "",
    },
    VPC: {
      Description: "The ID of the VPC",
      Type: "AWS::EC2::VPC::Id",
    },
    ApplicationSubnetIds: {
      Type: "List<AWS::EC2::Subnet::Id>",
      Description:
        "Choose two Public Subnets in different Availability Zones for public clusters or Private Subnets for non-internet facing clusters.",
    },
    LoadBalancerSubnetIds: {
      Type: "List<AWS::EC2::Subnet::Id>",
      Description:
        "Choose two public subnets if Load Balancer should be internet-facing or private subnets if Load Balancer should be internal. Make sure to choose Subnets in different Availability Zones.",
    },
    LoadBalancerType: {
      Description:
        "Specify the type of Load Balancer required for the application",
      Type: "String",
      Default: "Network",
      AllowedValues: ["Network", "Application"],
    },
    LoadBalancerScheme: {
      Description:
        "Indicates whether the load balancer in front of the EC2 Instance is internet-facing or internal.",
      Type: "String",
      Default: "internet-facing",
      AllowedValues: ["internet-facing", "internal"],
    },
    ApplicationInstanceType: {
      Description: "The instance type of the Application Server.",
      Type: "String",
      Default: "t2.medium",
      AllowedValues: [
        "t2.micro",
        "t2.medium",
        "t2.small",
        "t2.large",
        "t2.xlarge",
        "t2.2xlarge",
        "t3a.small",
        "t3a.medium",
        "t3a.large",
        "t3a.xlarge",
        "t3a.2xlarge",
        "m5a.xlarge",
        "m5a.2xlarge",
        "m5a.4xlarge",
        "m5a.8xlarge",
        "m5a.12xlarge",
        "m5a.16xlarge",
        "m5a.24xlarge",
        "c5.large",
        "c5.xlarge",
        "c5.2xlarge",
        "c5.4xlarge",
        "c5.9xlarge",
        "c5.12xlarge",
        "c5.18xlarge",
        "c5.24xlarge",
        "m5.large",
        "m5.xlarge",
        "m5.2xlarge",
        "m5.4xlarge",
        "m5.8xlarge",
        "m5.12xlarge",
        "m5.16xlarge",
        "m5.24xlarge",
      ],
    },
    ApplicationAMI: {
      Description: "The Application AMI ID.",
      Type: "String",
    },
    MaxSize: {
      Description: "The maximum size of the Auto Scaling group.",
      Type: "Number",
      Default: 4,
      ConstraintDescription: "Must be >= 1",
      MinValue: 1,
    },
    MinSize: {
      Description: "The minimum size of the Auto Scaling group.",
      Type: "Number",
      Default: 2,
      ConstraintDescription: "Must be >= 0",
      MinValue: 0,
    },
    ApplicationServerName: {
      Description: "Name of the Application Server",
      Type: "String",
    },
    InstancesRootVolumeSize: {
      Type: "Number",
      Description:
        "The volume size for the Application Server, in gibibytes (GiBs)",
      Default: 50,
    },
    DesiredCount: {
      Description:
        "The desired count of the Instances in the Auto Scaling group",
      Type: "Number",
      Default: 2,
      ConstraintDescription: "Must be >= 0",
      MinValue: 0,
    },
    ApplicationPort: {
      Type: "Number",
      Description: "Port number on the Application Server",
      Default: 80,
    },
    CPUPolicyTargetValue: {
      Type: "Number",
      Description: "CPU Utilization Target Value in Percentage",
      Default: 60,
    },
    EnableELBAccessLogs: {
      Description:
        "Enables Load Balancer Access logs and stores in a S3 Bucket.",
      Type: "String",
      Default: "true",
      AllowedValues: ["true", "false"],
    },
    DatabaseSecurityGroupId: {
      Description:
        "Optional, Database or any other Security Group Id to be attached to the Auto-Scaling Security Group",
      Type: "String",
    },
    RemoteAccessCIDR: {
      AllowedPattern:
        "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\\/([0-9]|[1-2][0-9]|3[0-2]))$",
      ConstraintDescription:
        "CIDR block parameter must be in the form x.x.x.x/x",
      Description:
        "Allowed CIDR block for external access to the Application Server.",
      Type: "String",
      Default: "0.0.0.0/0",
    },
    SubDomainName: {
      Description:
        "Name that is used to create the DNS entry with trailing dot Eg. {Subdomainname.}",
      Type: "String",
      Default: "",
    },
    HostedZoneName: {
      Description:
        "Optional Route 53 Hosted Zone Name with trailing dot. Eg. {hostedzonename.com.} Leave it blank if you dont have one.",
      Type: "String",
      Default: "",
    },
    CertificateARN: {
      Description:
        "Optional Amazon Certificate ARN. Leave it blank if you dont have one",
      Type: "String",
      Default: "",
    },
    DisableScaleIn: {
      Description:
        "Indicates whether scale in property of the Auto-Scaling scaling policy is disabled.",
      Type: "String",
      Default: "false",
      AllowedValues: ["true", "false"],
    },
    LoadBalancerDeregistrationDelay: {
      Description:
        "The amount time (in seconds) to wait before changing the state of a deregistering target from draining to unused.",
      Type: "Number",
      Default: 300,
      ConstraintDescription: "Must be in the range [0-3600]",
      MinValue: 0,
      MaxValue: 3600,
    },
    LoadBalancerIdleTimeout: {
      Description: "The idle timeout value, in seconds.",
      Type: "Number",
      Default: 60,
      MinValue: 1,
      MaxValue: 4000,
    },
  },
  Rules: {
    SubnetsInVPC: {
      Assertions: [
        {
          Assert: {
            "Fn::EachMemberIn": [
              {
                "Fn::ValueOfAll": ["AWS::EC2::Subnet::Id", "VpcId"],
              },
              {
                "Fn::RefAll": "AWS::EC2::VPC::Id",
              },
            ],
          },
          AssertDescription: "All subnets must in the VPC",
        },
      ],
    },
  },
  Conditions: {
    HasKeyName: {
      "Fn::Not": [
        {
          "Fn::Equals": [
            {
              Ref: "KeyName",
            },
            "",
          ],
        },
      ],
    },
    IfDatabaseSecurityGroupId: {
      "Fn::Not": [
        {
          "Fn::Equals": [
            {
              Ref: "DatabaseSecurityGroupId",
            },
            "",
          ],
        },
      ],
    },
    HasS3Bucket: {
      "Fn::Equals": [
        {
          Ref: "EnableELBAccessLogs",
        },
        "true",
      ],
    },
    NeedNLB: {
      "Fn::Equals": [
        {
          Ref: "LoadBalancerType",
        },
        "Network",
      ],
    },
    NeedALB: {
      "Fn::Equals": [
        {
          Ref: "LoadBalancerType",
        },
        "Application",
      ],
    },
    IfApplicationPort: {
      "Fn::Or": [
        {
          "Fn::Not": [
            {
              "Fn::Equals": [
                {
                  Ref: "ApplicationPort",
                },
                "80",
              ],
            },
          ],
        },
        {
          "Fn::Not": [
            {
              "Fn::Equals": [
                {
                  Ref: "ApplicationPort",
                },
                "443",
              ],
            },
          ],
        },
      ],
    },
    HasLoadBalancerSchemeInternal: {
      "Fn::Equals": [
        {
          Ref: "LoadBalancerScheme",
        },
        "internal",
      ],
    },
    HasManagedPolicyArns: {
      "Fn::Not": [
        {
          "Fn::Equals": [
            {
              Ref: "ManagedPolicyArns",
            },
            "",
          ],
        },
      ],
    },
    HasZone: {
      "Fn::Not": [
        {
          "Fn::Equals": [
            {
              Ref: "HostedZoneName",
            },
            "",
          ],
        },
      ],
    },
    HasLoadBalancerCertificateArn: {
      "Fn::And": [
        {
          "Fn::Not": [
            {
              "Fn::Equals": [
                {
                  Ref: "CertificateARN",
                },
                "",
              ],
            },
          ],
        },
        {
          "Fn::Equals": [
            {
              Ref: "LoadBalancerType",
            },
            "Application",
          ],
        },
      ],
    },
  },
  Resources: {
    ELBLogBucket: {
      Condition: "HasS3Bucket",
      Type: "AWS::S3::Bucket",
      DeletionPolicy: "Retain",
      Properties: {
        AccessControl: "LogDeliveryWrite",
        LifecycleConfiguration: {
          Rules: [
            {
              AbortIncompleteMultipartUpload: {
                DaysAfterInitiation: 7,
              },
              ExpirationInDays: 366,
              Id: "delete_old_versions",
              Status: "Enabled",
            },
          ],
        },
        Tags: [
          {
            Key: "Environment",
            Value: {
              Ref: "Environment",
            },
          },
          {
            Key: "Application",
            Value: {
              Ref: "Application",
            },
          },
        ],
      },
    },
    ELBLogBucketBucketPolicy: {
      Type: "AWS::S3::BucketPolicy",
      Condition: "HasS3Bucket",
      Properties: {
        Bucket: {
          Ref: "ELBLogBucket",
        },
        PolicyDocument: {
          Version: "2012-10-17",
          Statement: [
            {
              Sid: "AWSLogDeliveryWrite",
              Effect: "Allow",
              Principal: "*",
              Action: ["s3:GetObject*", "s3:PutObject*", "s3:DeleteObject*"],
              Resource: [
                {
                  "Fn::Sub": "arn:aws:s3:::${ELBLogBucket}",
                },
                {
                  "Fn::Sub": "arn:aws:s3:::${ELBLogBucket}/*",
                },
              ],
            },
            {
              Sid: "AWSLogDeliveryAclCheck",
              Effect: "Allow",
              Principal: "*",
              Action: ["s3:GetBucketAcl"],
              Resource: [
                {
                  "Fn::Sub": "arn:aws:s3:::${ELBLogBucket}",
                },
              ],
            },
          ],
        },
      },
    },
    EC2InstanceProfile: {
      Type: "AWS::IAM::InstanceProfile",
      Properties: {
        Roles: [
          {
            Ref: "EC2InstanceRole",
          },
        ],
      },
    },
    EC2InstanceRole: {
      Type: "AWS::IAM::Role",
      Properties: {
        AssumeRolePolicyDocument: {
          Version: "2012-10-17",
          Statement: [
            {
              Effect: "Allow",
              Principal: {
                Service: "ec2.amazonaws.com",
              },
              Action: "sts:AssumeRole",
            },
          ],
        },
        ManagedPolicyArns: {
          "Fn::If": [
            "HasManagedPolicyArns",
            {
              "Fn::Split": [
                ",",
                {
                  Ref: "ManagedPolicyArns",
                },
              ],
            },
            {
              Ref: "AWS::NoValue",
            },
          ],
        },
        Policies: [
          {
            PolicyName: "SSMMangedInstancePolicy",
            PolicyDocument: {
              Version: "2012-10-17",
              Statement: [
                {
                  Effect: "Allow",
                  Action: [
                    "ssmmessages:*",
                    "ssm:UpdateInstanceInformation",
                    "ssm:DescribeAssociation",
                    "ssm:GetDeployablePatchSnapshotForInstance",
                    "ssm:GetDocument",
                    "ssm:DescribeDocument",
                    "ssm:GetManifest",
                    "ssm:GetParameter",
                    "ssm:GetParameters",
                    "ssm:ListAssociations",
                    "ssm:ListInstanceAssociations",
                    "ssm:PutInventory",
                    "ssm:PutComplianceItems",
                    "ssm:PutConfigurePackageResult",
                    "ssm:UpdateAssociationStatus",
                    "ssm:UpdateInstanceAssociationStatus",
                    "ssm:UpdateInstanceInformation",
                    "ec2messages:*",
                  ],
                  Resource: "*",
                },
              ],
            },
          },
          {
            PolicyName: "CloudWatchLogsAccess",
            PolicyDocument: {
              Version: "2012-10-17",
              Statement: [
                {
                  Effect: "Allow",
                  Action: [
                    "logs:CreateLogGroup",
                    "logs:CreateLogStream",
                    "logs:PutLogEvents",
                    "logs:DescribeLogStreams",
                  ],
                  Resource: "*",
                },
              ],
            },
          },
        ],
      },
    },
    ASGSecurityGroup: {
      Type: "AWS::EC2::SecurityGroup",
      Properties: {
        GroupDescription: "Application Auto Scaling Security Group Rules",
        VpcId: {
          Ref: "VPC",
        },
        Tags: [
          {
            Key: "Environment",
            Value: {
              Ref: "Environment",
            },
          },
        ],
        SecurityGroupIngress: [
          {
            CidrIp: {
              Ref: "RemoteAccessCIDR",
            },
            FromPort: 80,
            ToPort: 80,
            IpProtocol: "tcp",
          },
          {
            CidrIp: {
              Ref: "RemoteAccessCIDR",
            },
            FromPort: 443,
            ToPort: 443,
            IpProtocol: "tcp",
          },
        ],
      },
    },
    ASGSecurityGroupIngress: {
      DependsOn: "ASGSecurityGroup",
      Condition: "IfApplicationPort",
      Type: "AWS::EC2::SecurityGroupIngress",
      Properties: {
        IpProtocol: "tcp",
        FromPort: {
          Ref: "ApplicationPort",
        },
        ToPort: {
          Ref: "ApplicationPort",
        },
        CidrIp: {
          Ref: "RemoteAccessCIDR",
        },
        GroupId: {
          "Fn::GetAtt": ["ASGSecurityGroup", "GroupId"],
        },
      },
    },
    ASGSecurityGroupDBIngress: {
      DependsOn: "ASGSecurityGroup",
      Condition: "IfDatabaseSecurityGroupId",
      Type: "AWS::EC2::SecurityGroupIngress",
      Properties: {
        IpProtocol: "-1",
        FromPort: "-1",
        ToPort: "-1",
        GroupId: {
          "Fn::GetAtt": ["ASGSecurityGroup", "GroupId"],
        },
        SourceSecurityGroupId: {
          Ref: "DatabaseSecurityGroupId",
        },
      },
    },
    NetworkLoadBalancer: {
      Type: "AWS::ElasticLoadBalancingV2::LoadBalancer",
      Condition: "NeedNLB",
      Properties: {
        Scheme: {
          Ref: "LoadBalancerScheme",
        },
        Type: "network",
        IpAddressType: "ipv4",
        LoadBalancerAttributes: [
          {
            Key: "load_balancing.cross_zone.enabled",
            Value: "true",
          },
          {
            Key: "access_logs.s3.enabled",
            Value: {
              Ref: "EnableELBAccessLogs",
            },
          },
          {
            "Fn::If": [
              "HasS3Bucket",
              {
                Key: "access_logs.s3.bucket",
                Value: {
                  Ref: "ELBLogBucket",
                },
              },
              {
                Ref: "AWS::NoValue",
              },
            ],
          },
        ],
        SubnetMappings: [
          {
            AllocationId: {
              "Fn::GetAtt": ["EIPA", "AllocationId"],
            },
            SubnetId: {
              "Fn::Select": [
                "0",
                {
                  Ref: "LoadBalancerSubnetIds",
                },
              ],
            },
          },
          {
            AllocationId: {
              "Fn::GetAtt": ["EIPB", "AllocationId"],
            },
            SubnetId: {
              "Fn::Select": [
                "1",
                {
                  Ref: "LoadBalancerSubnetIds",
                },
              ],
            },
          },
        ],
        Tags: [
          {
            Key: "Environment",
            Value: {
              Ref: "Environment",
            },
          },
        ],
      },
    },
    EIPA: {
      Type: "AWS::EC2::EIP",
      Condition: "NeedNLB",
      Properties: {
        Domain: "vpc",
      },
    },
    EIPB: {
      Type: "AWS::EC2::EIP",
      Condition: "NeedNLB",
      Properties: {
        Domain: "vpc",
      },
    },
    NLBTargetGroup: {
      Type: "AWS::ElasticLoadBalancingV2::TargetGroup",
      Condition: "NeedNLB",
      Properties: {
        HealthCheckIntervalSeconds: 30,
        HealthCheckPath: "/",
        HealthCheckProtocol: "HTTP",
        HealthyThresholdCount: 3,
        UnhealthyThresholdCount: 3,
        Matcher: {
          HttpCode: "200-399",
        },
        Port: {
          Ref: "ApplicationPort",
        },
        Protocol: "TCP",
        TargetType: "instance",
        VpcId: {
          Ref: "VPC",
        },
        Tags: [
          {
            Key: "Environment",
            Value: {
              Ref: "Environment",
            },
          },
        ],
        TargetGroupAttributes: [
          {
            Key: "stickiness.enabled",
            Value: true,
          },
          {
            Key: "deregistration_delay.timeout_seconds",
            Value: {
              Ref: "LoadBalancerDeregistrationDelay",
            },
          },
        ],
      },
    },
    NLBHttpListener: {
      Type: "AWS::ElasticLoadBalancingV2::Listener",
      Condition: "NeedNLB",
      Properties: {
        DefaultActions: [
          {
            TargetGroupArn: {
              Ref: "NLBTargetGroup",
            },
            Type: "forward",
          },
        ],
        LoadBalancerArn: {
          Ref: "NetworkLoadBalancer",
        },
        Port: 80,
        Protocol: "TCP",
      },
    },
    HttpsListener: {
      Type: "AWS::ElasticLoadBalancingV2::Listener",
      Condition: "HasLoadBalancerCertificateArn",
      Properties: {
        Certificates: [
          {
            CertificateArn: {
              Ref: "CertificateARN",
            },
          },
        ],
        DefaultActions: [
          {
            TargetGroupArn: {
              Ref: "ALBTargetGroup",
            },
            Type: "forward",
          },
        ],
        LoadBalancerArn: {
          Ref: "ApplicationLoadBalancer",
        },
        Port: 443,
        Protocol: "HTTPS",
      },
    },
    LaunchTemplate: {
      Type: "AWS::EC2::LaunchTemplate",
      Properties: {
        LaunchTemplateData: {
          InstanceType: {
            Ref: "ApplicationInstanceType",
          },
          DisableApiTermination: true,
          KeyName: {
            "Fn::If": [
              "HasKeyName",
              {
                Ref: "KeyName",
              },
              {
                Ref: "AWS::NoValue",
              },
            ],
          },
          ImageId: {
            Ref: "ApplicationAMI",
          },
          BlockDeviceMappings: [
            {
              DeviceName: "/dev/sda1",
              Ebs: {
                VolumeSize: {
                  Ref: "InstancesRootVolumeSize",
                },
                Encrypted: false,
                VolumeType: "gp2",
              },
            },
          ],
          IamInstanceProfile: {
            Arn: {
              "Fn::GetAtt": ["EC2InstanceProfile", "Arn"],
            },
          },
          SecurityGroupIds: [
            {
              Ref: "ASGSecurityGroup",
            },
          ],
        },
        LaunchTemplateName: {
          "Fn::Sub": "${AWS::StackName}-launch-template",
        },
      },
    },
    AutoScalingGroup: {
      Type: "AWS::AutoScaling::AutoScalingGroup",
      Properties: {
        LaunchTemplate: {
          LaunchTemplateId: {
            Ref: "LaunchTemplate",
          },
          Version: {
            "Fn::GetAtt": ["LaunchTemplate", "LatestVersionNumber"],
          },
        },
        MinSize: {
          Ref: "MinSize",
        },
        MaxSize: {
          Ref: "MaxSize",
        },
        DesiredCapacity: {
          Ref: "DesiredCount",
        },
        Cooldown: "300",
        HealthCheckGracePeriod: 180,
        HealthCheckType: "EC2",
        TerminationPolicies: ["Default"],
        TargetGroupARNs: [
          {
            "Fn::If": [
              "NeedNLB",
              {
                Ref: "NLBTargetGroup",
              },
              {
                Ref: "ALBTargetGroup",
              },
            ],
          },
        ],
        VPCZoneIdentifier: {
          Ref: "ApplicationSubnetIds",
        },
        Tags: [
          {
            Key: "Name",
            Value: {
              Ref: "ApplicationServerName",
            },
            PropagateAtLaunch: true,
          },
          {
            Key: "Environment",
            Value: {
              Ref: "Environment",
            },
            PropagateAtLaunch: true,
          },
        ],
      },
    },
    ApplicationScaleUpPolicy: {
      Type: "AWS::AutoScaling::ScalingPolicy",
      Properties: {
        AutoScalingGroupName: {
          Ref: "AutoScalingGroup",
        },
        Cooldown: "60",
        PolicyType: "TargetTrackingScaling",
        TargetTrackingConfiguration: {
          PredefinedMetricSpecification: {
            PredefinedMetricType: "ASGAverageCPUUtilization",
          },
          TargetValue: {
            Ref: "CPUPolicyTargetValue",
          },
          DisableScaleIn: {
            Ref: "DisableScaleIn",
          },
        },
      },
    },
    ApplicationLoadBalancer: {
      Type: "AWS::ElasticLoadBalancingV2::LoadBalancer",
      Condition: "NeedALB",
      Properties: {
        LoadBalancerAttributes: [
          {
            Key: "idle_timeout.timeout_seconds",
            Value: {
              Ref: "LoadBalancerIdleTimeout",
            },
          },
          {
            Key: "routing.http2.enabled",
            Value: "true",
          },
          {
            Key: "access_logs.s3.enabled",
            Value: {
              Ref: "EnableELBAccessLogs",
            },
          },
          {
            "Fn::If": [
              "HasS3Bucket",
              {
                Key: "access_logs.s3.bucket",
                Value: {
                  Ref: "ELBLogBucket",
                },
              },
              {
                Ref: "AWS::NoValue",
              },
            ],
          },
        ],
        Scheme: {
          Ref: "LoadBalancerScheme",
        },
        Type: "application",
        SecurityGroups: [
          {
            Ref: "ALBSecurityGroup",
          },
        ],
        Subnets: {
          Ref: "LoadBalancerSubnetIds",
        },
      },
    },
    ALBTargetGroup: {
      Type: "AWS::ElasticLoadBalancingV2::TargetGroup",
      Condition: "NeedALB",
      Properties: {
        HealthCheckIntervalSeconds: 30,
        HealthyThresholdCount: 2,
        UnhealthyThresholdCount: 2,
        Port: {
          Ref: "ApplicationPort",
        },
        Protocol: "HTTP",
        TargetType: "instance",
        VpcId: {
          Ref: "VPC",
        },
        TargetGroupAttributes: [
          {
            Key: "deregistration_delay.timeout_seconds",
            Value: {
              Ref: "LoadBalancerDeregistrationDelay",
            },
          },
          {
            Key: "stickiness.enabled",
            Value: true,
          },
        ],
      },
    },
    ALBHttpListener: {
      Type: "AWS::ElasticLoadBalancingV2::Listener",
      Condition: "NeedALB",
      Properties: {
        DefaultActions: [
          {
            TargetGroupArn: {
              Ref: "ALBTargetGroup",
            },
            Type: "forward",
          },
        ],
        LoadBalancerArn: {
          Ref: "ApplicationLoadBalancer",
        },
        Port: {
          Ref: "ApplicationPort",
        },
        Protocol: "HTTP",
      },
    },
    ALBSecurityGroup: {
      Type: "AWS::EC2::SecurityGroup",
      Condition: "NeedALB",
      Properties: {
        GroupDescription: "Application Security Group",
        VpcId: {
          Ref: "VPC",
        },
        SecurityGroupIngress: [
          {
            "Fn::If": [
              "IfApplicationPort",
              {
                CidrIp: {
                  Ref: "RemoteAccessCIDR",
                },
                FromPort: {
                  Ref: "ApplicationPort",
                },
                ToPort: {
                  Ref: "ApplicationPort",
                },
                IpProtocol: "tcp",
              },
              {
                Ref: "AWS::NoValue",
              },
            ],
          },
        ],
      },
    },
    ALBSecurityGroupInHttpWorld: {
      Type: "AWS::EC2::SecurityGroupIngress",
      Condition: "NeedALB",
      Properties: {
        GroupId: {
          Ref: "ALBSecurityGroup",
        },
        IpProtocol: "tcp",
        FromPort: 80,
        ToPort: 80,
        CidrIp: "0.0.0.0/0",
      },
    },
    ALBSecurityGroupInHttpsWorld: {
      Type: "AWS::EC2::SecurityGroupIngress",
      Condition: "NeedALB",
      Properties: {
        GroupId: {
          Ref: "ALBSecurityGroup",
        },
        IpProtocol: "tcp",
        FromPort: 443,
        ToPort: 443,
        CidrIp: "0.0.0.0/0",
      },
    },
    RecordSet: {
      Condition: "HasZone",
      Type: "AWS::Route53::RecordSet",
      Properties: {
        AliasTarget: {
          HostedZoneId: {
            "Fn::If": [
              "NeedNLB",
              {
                "Fn::GetAtt": ["NetworkLoadBalancer", "CanonicalHostedZoneID"],
              },
              {
                "Fn::GetAtt": [
                  "ApplicationLoadBalancer",
                  "CanonicalHostedZoneID",
                ],
              },
            ],
          },
          DNSName: {
            "Fn::If": [
              "NeedNLB",
              {
                "Fn::GetAtt": ["NetworkLoadBalancer", "DNSName"],
              },
              {
                "Fn::GetAtt": ["ApplicationLoadBalancer", "DNSName"],
              },
            ],
          },
        },
        Name: {
          "Fn::Sub": "${SubDomainName}${HostedZoneName}",
        },
        HostedZoneName: {
          Ref: "HostedZoneName",
        },
        Type: "A",
      },
    },
  },
  Outputs: {
    ParentStack: {
      Description: "Stack name.",
      Value: {
        "Fn::Sub": "${AWS::StackName}",
      },
    },
    AppURL: {
      Condition: "HasZone",
      Description: "Application URL.",
      Value: {
        "Fn::If": [
          "HasZone",
          {
            "Fn::Sub": "http://${RecordSet}",
          },
          "Not Applied - No Domain Name provided",
        ],
      },
    },
    AppSecureURL: {
      Condition: "HasLoadBalancerCertificateArn",
      Description: "Application Secure URL.",
      Value: {
        "Fn::If": [
          "HasLoadBalancerCertificateArn",
          {
            "Fn::Sub": "https://${RecordSet}",
          },
          "Not Applied - No Certificate provided",
        ],
      },
    },
    AutoScalingGroup: {
      Description: "Application AutoScalingGroup name.",
      Value: {
        Ref: "AutoScalingGroup",
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-AutoScalingGroup",
        },
      },
    },
    LoadBalancer: {
      Description: "Elastic Load Balancer Full Name.",
      Value: {
        "Fn::If": [
          "NeedNLB",
          {
            "Fn::GetAtt": ["NetworkLoadBalancer", "LoadBalancerFullName"],
          },
          {
            "Fn::GetAtt": ["ApplicationLoadBalancer", "LoadBalancerFullName"],
          },
        ],
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-LoadBalancer",
        },
      },
    },
    LoadBalancerARN: {
      Description: "Elastic Load Balancer ARN",
      Value: {
        "Fn::If": [
          "NeedNLB",
          {
            Ref: "NetworkLoadBalancer",
          },
          {
            Ref: "ApplicationLoadBalancer",
          },
        ],
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-LoadBalancerARN",
        },
      },
    },
    TargetGroupARN: {
      Description: "Elastic Load Balancer Target Group ARN.",
      Value: {
        "Fn::If": [
          "NeedNLB",
          {
            Ref: "NLBTargetGroup",
          },
          {
            Ref: "ALBTargetGroup",
          },
        ],
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-TargetGroupARN",
        },
      },
    },
    LoadBalancerType: {
      Description: "Elastic Load Balancer Type",
      Value: {
        Ref: "LoadBalancerType",
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-LoadBalancerType",
        },
      },
    },
    TargetGroupFullname: {
      Description: "Elastic Load Balancer Target Group Full Name.",
      Value: {
        "Fn::If": [
          "NeedNLB",
          {
            "Fn::GetAtt": ["NLBTargetGroup", "TargetGroupFullName"],
          },
          {
            "Fn::GetAtt": ["ALBTargetGroup", "TargetGroupFullName"],
          },
        ],
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-TargetGroupFullname",
        },
      },
    },
    HttpListener: {
      Description: "Elastic Load Balancer HTTP listener for services.",
      Value: {
        "Fn::If": [
          "NeedNLB",
          {
            Ref: "NLBHttpListener",
          },
          {
            Ref: "ALBHttpListener",
          },
        ],
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-HttpListener",
        },
      },
    },
    VPC: {
      Description: "VPC ID.",
      Value: {
        Ref: "VPC",
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-VPC",
        },
      },
    },
    SecurityGroup: {
      Description: "Security Group Name for Auto Scaling Group.",
      Value: {
        Ref: "ASGSecurityGroup",
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-SecurityGroup",
        },
      },
    },
    DNSName: {
      Description: "The DNS name for the Elastic load balancer.",
      Value: {
        "Fn::If": [
          "NeedNLB",
          {
            "Fn::GetAtt": ["NetworkLoadBalancer", "DNSName"],
          },
          {
            "Fn::GetAtt": ["ApplicationLoadBalancer", "DNSName"],
          },
        ],
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-DNSName",
        },
      },
    },
    NLBURL: {
      Condition: "NeedNLB",
      Description: "URL to the Application Server.",
      Value: {
        "Fn::Sub": "http://${NetworkLoadBalancer.DNSName}",
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-NLB-URL",
        },
      },
    },
    ALBURL: {
      Condition: "NeedALB",
      Description: "URL to the Application Server.",
      Value: {
        "Fn::Sub": "http://${ApplicationLoadBalancer.DNSName}",
      },
      Export: {
        Name: {
          "Fn::Sub": "${AWS::StackName}-ALB-URL",
        },
      },
    },
  },
};
